enum PassengerAddViewMode {
  CARGO = "CARGO",
  RAILY = "RAILY",
}

export default PassengerAddViewMode;
